import { stringify } from 'querystring';
import { BaseModel } from '../../../../../../core/_base/crud';
export class YeuCauDuyetGia extends BaseModel {

    static category_path = "KDYCDG";
    static optionsTinhTrang = [
        {
            id: 3,
            name: 'Đang soạn thảo',
            value: 'KDYCDG_DANGSOANTHAO',
            show: true
        },
        {
            id: 4,
            name: 'Chờ duyệt',
            value: 'KDYCDG_CHODUYET',
            show: true
        },
        {
            id: 5,
            name: 'Không duyệt',
            value: 'KDYCDG_KHONGDUYET',
            show: true
        },
        {
            id: 6,
            name: 'Hoàn tất',
            value: 'KDYCDG_HOANTAT',
            show: true
        },
        {
            id: 7,
            name: 'Đã hủy',
            value: 'KDYCDG_DAHUY',
            show: true
        },
        {
            id: 8,
            name: 'Chờ khách hàng feedback',
            value: 'KDYCDG_CHOKHACHHANGFEEDBACK',
            show: true
        },
        {
            id: 1,
            name: 'Chờ xem xét',
            value: 'KDYCDG_CHOXEMXET',
            show: true
        },
        {
            id: 2,
            name: 'Không đồng ý',
            value: 'KDYCDG_KHONGDONGY',
            show: true
        }
    ];

    IdDG: number
    SoPhieu: string
    NgayLapPhieu: string
    NguoiLapPhieu: number
    TenNguoiLapPhieu: string
    TrangThai_Code: string
    TrangThai_Desc: string
    IdKH: number
    MaKH: string
    TenKH: string
    NgayDuyet: string
    NguoiDuyet: number
    TenNguoiDuyet: string
    LyDo: string
    IdYCBG: number
    SoPhieuYCBG: string
    YCBGCT: number
    DanhSachHangHoa: ListHangHoa[]
    IdHH: string
    MaHH: string
    TenHH: string
    NgayYCBG: Date
    SoLuong: number
    GiaDeNghiBan: number
    ThoiGianGiuGia: number
    NgayYeuCauGiaoHang: Date
    ThanhTien: number
    TyGia: number
    ThanhTienQuyDoi: number
    TienTeId: number
    QuyCachDongGoi: string
    GhiChu: string
    TenDVT: string
    GiaGanNhat: number
    GiaKhachHangMongMuon: number
    TotalSoluongton: number
    GiaMin: number
    GiaMax: number
    BusinessModel: string
    clear() {
        this.IdDG = 0
        this.SoPhieu = ''
        this.NgayLapPhieu = ''
        this.NguoiLapPhieu = 0
        this.TenNguoiLapPhieu = ''
        this.TrangThai_Code = ''
        this.TrangThai_Desc = ''
        this.IdKH = 0
        this.MaKH = ''
        this.TenKH = ''
        this.NgayDuyet = ''
        this.NguoiDuyet = 0
        this.TenNguoiDuyet = ''
        this.LyDo = ''
        this.IdYCBG = 0
        this.SoPhieuYCBG = ''
        this.DanhSachHangHoa = []
        this.IdHH = '';
        this.YCBGCT = 0;
        this.MaHH = '';
        this.TenHH = '';
        this.NgayYCBG = new Date();
        this.SoLuong = 0;
        this.GiaDeNghiBan = 0;
        this.ThoiGianGiuGia = 1;
        this.NgayYeuCauGiaoHang = new Date();
        this.ThanhTien = 0;
        this.TyGia = 1;
        this.ThanhTienQuyDoi = 0;
        this.TienTeId = 0;
        this.QuyCachDongGoi = '';
        this.GhiChu = '';
        this.TenDVT = '';
        this.GiaGanNhat = 0;
        this.GiaKhachHangMongMuon = 0;
        this.TotalSoluongton = 0;
        this.GiaMin = 0;
        this.GiaMax = 0;
        this.BusinessModel = ''
    }
    copy(item: YeuCauDuyetGia) {
        this.IdDG = item.IdDG;
        this.SoPhieu = item.SoPhieu
        this.NgayLapPhieu = item.NgayLapPhieu
        this.NguoiLapPhieu = item.NguoiLapPhieu
        this.TenNguoiLapPhieu = item.TenNguoiLapPhieu
        this.TrangThai_Code = item.TrangThai_Code
        this.TrangThai_Desc = item.TrangThai_Desc
        this.IdKH = item.IdKH
        this.MaKH = item.MaKH
        this.TenKH = item.TenKH
        this.NgayDuyet = item.NgayDuyet
        this.NguoiDuyet = item.NguoiDuyet
        this.TenNguoiDuyet = item.TenNguoiDuyet
        this.LyDo = item.LyDo
        this.IdYCBG = item.IdYCBG
        this.SoPhieuYCBG = item.SoPhieuYCBG
        this.DanhSachHangHoa = item.DanhSachHangHoa
        this.IdHH = item.IdHH;
        this.YCBGCT = item.YCBGCT;
        this.MaHH = item.MaHH;
        this.TenHH = item.TenHH;
        this.NgayYCBG = item.NgayYCBG;
        this.SoLuong = item.SoLuong;
        this.GiaDeNghiBan = item.GiaDeNghiBan;
        this.ThoiGianGiuGia = item.ThoiGianGiuGia;
        this.NgayYeuCauGiaoHang = item.NgayYeuCauGiaoHang;
        this.ThanhTien = item.ThanhTien;
        this.ThanhTienQuyDoi = item.ThanhTienQuyDoi;
        this.TyGia = item.TyGia;
        this.TienTeId = item.TienTeId;
        this.QuyCachDongGoi = item.QuyCachDongGoi;
        this.GhiChu = item.GhiChu;
        this.TenDVT = item.TenDVT;
        this.GiaGanNhat = item.GiaGanNhat;
        this.GiaKhachHangMongMuon = item.GiaKhachHangMongMuon;
        this.TotalSoluongton = item.TotalSoluongton;
        this.GiaMin = item.GiaMin;
        this.GiaMax = item.GiaMax;
        this.BusinessModel = item.BusinessModel;
    }
}
export class ListHangHoa extends BaseModel {
    IdHH: number
    MaHH: string
    TenHH: string
    QuyCach: string
    DVT: number
    TenDVT: string
    SoLuong: number
    SoLo: number
    SLTon: number
    GiaRecommand: number
    GiaMoi: number
    ThoiHanGiuGia: number
    NgayYeuCauGH: string
    KetLuan: number
    TienTe_Id: number
    TyGia: number
    ThanhTien: number
    ThanhTienQuyDoi: number
    YCBGCT: number
    clear() {
        this.IdHH = 0
        this.MaHH = ''
        this.TenHH = ''
        this.QuyCach = ''
        this.DVT = 0
        this.TenDVT = ''
        this.SoLuong = 0
        this.SoLo = 0
        this.SLTon = 0
        this.GiaRecommand = 0
        this.GiaMoi = 0
        this.ThoiHanGiuGia = 1
        this.NgayYeuCauGH = ''
        this.KetLuan = 0
        this.TienTe_Id = -1
        this.TyGia = 1
        this.ThanhTien = 0
        this.ThanhTienQuyDoi = 0
        this.YCBGCT = 0
    }

    copy(item: ListHangHoa) {
        this.IdHH = item.IdHH
        this.MaHH = item.MaHH
        this.TenHH = item.TenHH
        this.QuyCach = item.QuyCach
        this.TenDVT = item.TenDVT
        this.DVT = item.DVT
        this.SoLuong = item.SoLuong
        this.SoLo = item.SoLo
        this.SLTon = item.SLTon
        this.GiaRecommand = item.GiaRecommand
        this.GiaMoi = item.GiaMoi
        this.ThoiHanGiuGia = item.ThoiHanGiuGia
        this.NgayYeuCauGH = item.NgayYeuCauGH
        this.KetLuan = item.KetLuan
        this.TienTe_Id = item.TienTe_Id
        this.TyGia = item.TyGia
        this.ThanhTien = item.ThanhTien
        this.ThanhTienQuyDoi = item.ThanhTienQuyDoi
        this.YCBGCT = item.YCBGCT
    }
}
export class YeuCauDuyetGiaChiTiet extends BaseModel {
    IdCt: number
    IdYC: number
    YCBGCT: number
    IdHH: number
    MaHH: string
    TenHH: string
    QuyCach: string
    DVT: number
    TenDVT: string
    KhoiLuong: number
    NgayYeuCauGH: string
    ThoiHanGiuGia: number
    TienTe_Id: number
    TienTe_Ten: string
    TyGia: number
    GiaMoi: number
    TongSLTon: number
    IdLo: number
    SoLo: string
    SLTon: number
    GiaRecommend: number
    ThanhTien: number
    ThanhTienQuyDoi: number
    ListSoLo: any[]
    KLSaiSo: number
    KHFeedback: string
    KHDongY: boolean
    clear() {
        this.IdCt = 0
        this.IdYC = 0
        this.YCBGCT = 0
        this.IdHH = 0
        this.MaHH = ''
        this.TenHH = ''
        this.QuyCach = ''
        this.DVT = 0
        this.TenDVT = ''
        this.KhoiLuong = 0
        this.NgayYeuCauGH = ''
        this.ThoiHanGiuGia = 0
        this.TienTe_Id = 0
        this.TienTe_Ten = ''
        this.TyGia = 0
        this.GiaMoi = 0
        this.TongSLTon = 0
        this.IdLo = 0
        this.SoLo = ''
        this.SLTon = 0
        this.GiaRecommend = 0
        this.ThanhTien = 0
        this.ThanhTienQuyDoi = 0
        this.ListSoLo = []
        this.KLSaiSo = null
        this.KHDongY = null;
        this.KHFeedback = ""
    }
    copy(item: YeuCauDuyetGiaChiTiet) {
        this.IdCt = item.IdCt
        this.IdYC = item.IdYC
        this.YCBGCT = item.YCBGCT
        this.IdHH = item.IdHH
        this.MaHH = item.MaHH
        this.TenHH = item.TenHH
        this.QuyCach = item.QuyCach
        this.DVT = item.DVT
        this.TenDVT = item.TenDVT
        this.KhoiLuong = item.KhoiLuong
        this.NgayYeuCauGH = item.NgayYeuCauGH
        this.ThoiHanGiuGia = item.ThoiHanGiuGia
        this.TienTe_Id = item.TienTe_Id
        this.TienTe_Ten = item.TienTe_Ten
        this.TyGia = item.TyGia
        this.GiaMoi = item.GiaMoi
        this.TongSLTon = item.TongSLTon
        this.IdLo = item.IdLo
        this.SoLo = item.SoLo
        this.SLTon = item.SLTon
        this.GiaRecommend = item.GiaRecommend
        this.ThanhTien = item.ThanhTien
        this.ThanhTienQuyDoi = item.ThanhTienQuyDoi
        this.ListSoLo = item.ListSoLo
        this.KLSaiSo = item.KLSaiSo
        this.KHDongY = item.KHDongY
        this.KHFeedback = item.KHFeedback
    }
}
export class YeuCauDuyetGiaList extends BaseModel {
    IdDG: number
    SoPhieu: string
    NgayLapPhieu: string
    TenNguoiLapPhieu: string
    TrangThai_Code: string
    TrangThai_Desc: string
    IdYCBG: number
    NgayYCBG: string
    IdKH: number
    MaKH: string
    TenKH: string
    SoPhieuYCBG: string
    Cts: any[]
    DanhSachHangHoa: ListHangHoa[]
    clear() {
        this.IdDG = 0
        this.SoPhieu = ''
        this.NgayLapPhieu = ''
        this.TenNguoiLapPhieu = ''
        this.TrangThai_Code = ''
        this.TrangThai_Desc = ''
        this.IdYCBG = 0
        this.NgayYCBG = ''
        this.IdKH = 0
        this.MaKH = ''
        this.TenKH = ''
        this.SoPhieuYCBG = ''
        this.Cts = [],
            this.DanhSachHangHoa = []
    }


}
export class YCDG extends BaseModel {
    IdDG: number
    SoPhieu: string
    NgayLapPhieu: string
    NguoiLapPhieu: number
    TenNguoiLapPhieu: string
    NgayYeuCauBaoGia: string
    YeuCauDuyetGiaDetailCT: DanhSachYCDG[]
    clear() {
        this.IdDG = 0
        this.SoPhieu = ''
        this.NgayLapPhieu = ''
        this.NguoiLapPhieu = 0
        this.TenNguoiLapPhieu = ''
        this.NgayYeuCauBaoGia = ''
        this.YeuCauDuyetGiaDetailCT = []
    }
}
export class DanhSachYCDG extends BaseModel {
    YCBGCT: number
    IdHH: number
    MaHH: string
    TenHH: string
    IdDVT: number
    SoLuong: number
    NgayYeuCauGH: string
    ThoiHanGiuGia: number
    TienTe_Id: number
    TienTe_Ten: string
    TyGia: number
    GiaMoi: number
    GiaGanNhat: number
    ThanhTien: number
    ThanhTienQuyDoi: number
    YCBG: string
    IdKH: number
    TenKH: string
    MaKH: string
    Min: number
    Max: number
    GiaKHDN: number
    TenDVT: string
    NgayDuyet: string
    TenNguoiDuyet: string
    LyDo: string
    TrangThai: string
    TrangThai_Code: string
    KLSaiSo: number
    clear() {
        this.YCBGCT = 0;
        this.IdHH = 0;
        this.MaHH = "";
        this.TenHH = "";
        this.IdDVT = 0;
        this.SoLuong = 0;
        this.NgayYeuCauGH = "";
        this.ThoiHanGiuGia = 0;
        this.TienTe_Id = 0;
        this.TienTe_Ten = "";
        this.TyGia = 0;
        this.GiaMoi = 0;
        this.GiaGanNhat = 0;
        this.ThanhTien = 0;
        this.ThanhTienQuyDoi = 0;
        this.YCBG = "";
        this.IdKH = 0;
        this.TenKH = "";
        this.MaKH = "";
        this.Min = 0;
        this.Max = 0;
        this.GiaKHDN = 0;
        this.TenDVT = "";
        this.NgayDuyet = "";
        this.TenNguoiDuyet = "";
        this.LyDo = "";
        this.TrangThai = "";
        this.TrangThai_Code = "";
        this.KLSaiSo = null;
    }
    copy(item: DanhSachYCDG) {
        this.YCBGCT = item.YCBGCT;
        this.IdHH = item.IdHH;
        this.MaHH = item.MaHH;
        this.TenHH = item.TenHH;
        this.IdDVT = item.IdDVT;
        this.SoLuong = item.SoLuong;
        this.NgayYeuCauGH = item.NgayYeuCauGH;
        this.ThoiHanGiuGia = item.ThoiHanGiuGia;
        this.TienTe_Id = item.TienTe_Id;
        this.TienTe_Ten = item.TienTe_Ten;
        this.TyGia = item.TyGia;
        this.GiaMoi = item.GiaMoi;
        this.GiaGanNhat = item.GiaGanNhat;
        this.ThanhTien = item.ThanhTien;
        this.ThanhTienQuyDoi = item.ThanhTienQuyDoi;
        this.YCBG = item.YCBG;
        this.IdKH = item.IdKH;
        this.TenKH = item.TenKH;
        this.MaKH = item.MaKH;
        this.Min = item.Min;
        this.Max = item.Max;
        this.GiaKHDN = item.GiaKHDN;
        this.TenDVT = item.TenDVT;
        this.NgayDuyet = item.NgayDuyet;
        this.TenNguoiDuyet = item.TenNguoiDuyet;
        this.LyDo = item.LyDo;
        this.TrangThai = item.TrangThai;
        this.TrangThai_Code = item.TrangThai_Code;
        this.KLSaiSo = item.KLSaiSo;
    }
}
export const YeuCauDuyetGiaConfig = {
    B2B: {
        PARAM_REQUEST_PRICE: "kd-yeu-cau-duyet-gia",
        TITLE_REQUEST_PRICE: "Danh sách yêu cầu duyệt giá B2B",
        BUSINESS_TYPE: "B2B"
    },
    B2C: {
        PARAM_REQUEST_PRICE: "kd-yeu-cau-duyet-gia-b2c",
        TITLE_REQUEST_PRICE: "Danh sách yêu cầu duyệt giá B2C",
        BUSINESS_TYPE: "B2C"
    }
};